import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-24 px-6 bg-charcoal-800 relative border-t border-charcoal-700" data-id="element-139">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[1px] bg-gradient-to-r from-transparent via-mutedred/30 to-transparent" data-id="element-140" />

      <div className="max-w-3xl mx-auto" data-id="element-141">
        <FadeIn data-id="element-142">
          <h2 className="font-heading text-4xl sm:text-5xl text-mutedred mb-8 leading-tight" data-id="element-143">
            El agotamiento crónico no es un problema de "gestión del tiempo". Es
            un problema químico.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-144">
          <div className="space-y-6 text-lg text-offwhite/80 font-light leading-relaxed" data-id="element-145">
            <p data-id="element-146">
              Tu sistema nervioso está secuestrado por el cortisol (la hormona
              del estrés) y no sabe cómo apagar el interruptor.
            </p>
            <p data-id="element-147">
              Vivís con el pecho apretado, neblina mental constante y esa
              irritabilidad silenciosa que muerde a tu familia cuando llegás a
              casa.
            </p>
            <p className="pl-6 border-l-2 border-mutedred/50 text-offwhite italic" data-id="element-148">
              Intentaste descansar, pero te despertás a las 3 AM con el corazón
              a mil porque tu cerebro cree que hay un incendio que apagar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}